var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProformaInvoice(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0827 9.91698V6.367C17.0827 3.00867 16.2993 2.16699 13.1493 2.16699H6.84935C3.69935 2.16699 2.91602 3.00867 2.91602 6.367V15.7503C2.91602 17.967 4.13269 18.492 5.60769 16.9087L5.61601 16.9003C6.29934 16.1753 7.34101 16.2336 7.93267 17.0253L8.77435 18.1503",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 6.33301H13.3327",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.66699H12.5",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 16.4824C13.5625 16.8723 13.8898 17.1913 14.288 17.1913H15.1061C15.4552 17.1913 15.7389 16.9128 15.7389 16.5735C15.7389 16.2038 15.5643 16.0722 15.308 15.9861L13.9989 15.5607C13.737 15.4746 13.5625 15.343 13.5625 14.9733C13.5625 14.634 13.8461 14.3555 14.1952 14.3555H15.0134C15.417 14.3605 15.7443 14.6745 15.7443 15.0644",
    stroke: "#322972",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6523 17.2168V17.5915",
    stroke: "#322972",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6523 13.9561V14.351",
    stroke: "#322972",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6523 19.7715C16.8615 19.7715 18.6523 17.9806 18.6523 15.7715C18.6523 13.5623 16.8615 11.7715 14.6523 11.7715C12.4432 11.7715 10.6523 13.5623 10.6523 15.7715C10.6523 17.9806 12.4432 19.7715 14.6523 19.7715Z",
    stroke: "#322972",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProformaInvoice);
export default __webpack_public_path__ + "static/media/proforma-invoice.d73e8e37a8fcbd80a55e36be0ae131c8.svg";
export { ForwardRef as ReactComponent };